module.exports = {
	"EOSQ051": {
		"descriptionQuestion": "In your country, to what extent are property rights, including financial assets, protected? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ051",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.52,
			6.67
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Property rights (1-7)",
		"shortTitle": "Property rights",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_PROPERTYPROTECT",
		"includedDashboard": "YES",
		"titleWithUnits": "Property rights*",
		"fullDescription": "",
		"GETR2016Number": "7.01.a"
	},
	"ETIB03": {
		"descriptionQuestion": "Pillar 3: Efficiency and transparency of border administration",
		"dataType": "AGGREG",
		"globalId": "ETIB03",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Efficiency and transparency of border administration (1–7)",
		"shortTitle": "Pillar 3: Efficiency and transparency of border administration",
		"otherShortTitle": "Efficiency & transparency of border administration",
		"parentCategoryGlobalId": "ETI.B",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 3: Efficiency and transparency of border administration (1–7)",
		"fullDescription": "This pillar assesses the efficiency and transparency of border administration. More specifically, it captures efficiency, transparency and costs associated with importing and exporting goods. It includes an assessment of the range, quality and comprehensiveness of key services offered by customs and related agencies, and the average time, costs and number of documents required to, respectively, import and export goods. The pillar also assesses the time predictability of border procedures, as well as the transparency of the process—as measured by the availability and quality of information provided by border agencies—and the prevalence of corruption",
		"GETR2016Number": "B.03"
	},
	"int_cooperation": {
		"descriptionQuestion": "Co-operation between various border agencies of the country; control delegation to customs authorities",
		"dataType": "HARD",
		"globalId": "int_cooperation",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Border agency cooperation - internal (0–2)",
		"shortTitle": "Border agency cooperation - internal",
		"otherShortTitle": "Border agency cooperation - internal",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Border agency cooperation - internal (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TFA Article 6": {
		"descriptionQuestion": "Disciplines on fees and charges imposed on or in connection with importation and exportation and penalties",
		"dataType": "HARD",
		"globalId": "TFA Article 6",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 6 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ146": {
		"descriptionQuestion": "In your country, how common is illegal diversion of public funds to companies, individuals or groups? (1 = very commonly occurs; 7 = never occurs)",
		"dataType": "SURVEY",
		"globalId": "EOSQ146",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.22,
			6.63
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Diversion of public funds (1-7)",
		"shortTitle": "Diversion of public funds",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_INSTITQUALITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Diversion of public funds*",
		"fullDescription": "",
		"GETR2016Number": "7.02.b"
	},
	"EOSQ366": {
		"descriptionQuestion": "In your country, to what extent do businesses use the Internet for selling their goods and services to consumers? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ366",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.2,
			6.4
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Internet use for business-to-consumer transactions (1–7)",
		"shortTitle": "Internet use for business-to-consumer transactions",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Internet use for business-to-consumer transactions*",
		"fullDescription": "",
		"GETR2016Number": "6.06"
	},
	"TABTIMEIMPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABTIMEIMPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0.5,
			1090
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Documentary compliance (hours)",
		"shortTitle": "Time to import: Documentary compliance",
		"otherShortTitle": "Time to import: Documentary compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Documentary compliance (hours)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.03"
	},
	"TABTIMEEXPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABTIMEEXPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			515.04
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Border compliance (hours)",
		"shortTitle": "Time to export: Border compliance",
		"otherShortTitle": "Time to export: Border compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Border compliance (hours)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.08"
	},
	"EOSQ033": {
		"descriptionQuestion": "In your country, to what extent does the threat of terrorism impose costs on businesses? (1 = to a great extent, imposes huge costs; 7 = no costs at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ033",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.74,
			6.8
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Business costs of terrorism (1-7)",
		"shortTitle": "Business costs of terrorism",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Business costs of terrorism*",
		"fullDescription": "",
		"GETR2016Number": "7.05.c"
	},
	"CUSTSERVIND": {
		"descriptionQuestion": "Index of extent of quality and comprehensiveness of services provided by customs authorities and related agencies (0 = worst, 1 = best)",
		"dataType": "HARD",
		"globalId": "CUSTSERVIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association (GEA) Customs Capabilities Database",
		"title": "Customs services index (0–1)",
		"shortTitle": "Customs services index",
		"otherShortTitle": "Customs services index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs services index (0–1)",
		"fullDescription": "This indicator is based on 17 survey questions taken from the GEA Customs Capabilities Reports, which evaluate the quality and comprehensiveness of services offered by customs and related agencies. The services included: clearance of shipments via electronic data interchange; separation of physical release of goods from fiscal control; full-time (24 hours/7 days a week) automated processing; customs working hours adapted to commercial needs; fee for services conducted during normal service hours; inspection and release of goods arriving by air by the operator's facility; automated risk assessment as primary basis for physical examination of shipments; multiple inspections (inspections by agencies other than customs) and the promptness of those inspections; exemptions from full customs formalities for shipments of minimal value; exemptions from a duties and taxes for shipments of minimal value; clearance of shipments by a third party; appeal of customs decisions to a higher level or an independent tribunal; and use of reference prices or arbitrary uplifts to invoice values. The maximum score an economy can obtain is 1.",
		"GETR2016Number": "3.01"
	},
	"TOTTARIFRT": {
		"descriptionQuestion": "Trade-weighted average applied tariff rate (%)",
		"dataType": "HARD",
		"globalId": "TOTTARIFRT",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariff rate (%)",
		"shortTitle": "Tariff rate",
		"otherShortTitle": "Tariff rate",
		"parentCategoryGlobalId": "ETI.A.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariff rate (%)",
		"fullDescription": "This indicator is calculated as a trade-weighted average of all the applied tariff rates, including preferential rates that a country applies to the rest of the world. The weights are the trade patterns of the importing country's reference group (2014 data). An applied tariff is a customs duty that is levied on imports of merchandise goods.",
		"GETR2016Number": "1.01"
	},
	"HOMICIDERT": {
		"descriptionQuestion": "Number of homicide cases per 100,000 population",
		"dataType": "HARD",
		"globalId": "HOMICIDERT",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			92.7
		],
		"sources": "United Nations Office on Drugs and Crime (UNODC)",
		"title": "Homicide cases/100,000 pop.",
		"shortTitle": "Homicide rate",
		"otherShortTitle": "Homicide rate",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Homicide cases/100,000 pop.",
		"fullDescription": "The United Nations Office on Drugs and Crime (UNODC) collects statistics on homicide occurrences worldwide, pooling information from national sources as well as other international institutions such as Interpol, Eurostat, the Organization of American States, UNICEF and the World Health Organization (WHO).",
		"GETR2016Number": "7.05.d"
	},
	"LINERSHIPIDX": {
		"descriptionQuestion": "Quantity of services provided by liner companies",
		"dataType": "HARD",
		"globalId": "LINERSHIPIDX",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			7,
			1
		],
		"sources": "United Nations Conference on Trade and Development (UNCTAD), Transport Section, Trade Logistics Branch ",
		"title": "Liner Shipping Connectivity Index (0–157.1)",
		"shortTitle": "Liner Shipping Connectivity Index",
		"otherShortTitle": "Liner Shipping Connectivity Index",
		"parentCategoryGlobalId": "ETI.C.04.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Liner Shipping Connectivity Index (0–157.1)",
		"fullDescription": "This indicator captures how well countries are connected to global shipping networks. It is based on five components of the maritime transport sector: number of ships, their container-carrying capacity, maximum vessel size, number of services and number of companies that deploy container ships in a country's ports. For each component, a country's value is divided by the maximum value of each component in 2004. The five components are then averaged for each country, and the average is divided by the maximum average for 2004 and multiplied by 100. The index generates a value of 100 for the country with the highest average index in 2004.",
		"GETR2016Number": "4.04"
	},
	"BBSUBPC": {
		"descriptionQuestion": "Fixed broadband Internet subscriptions per 100 population",
		"dataType": "HARD",
		"globalId": "BBSUBPC",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			44.79
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Fixed broadband Internet subscriptions/100 pop.",
		"shortTitle": "Fixed broadband Internet subscriptions",
		"otherShortTitle": "Broadband Internet subscriptions",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Fixed broadband Internet subscriptions/100 pop.",
		"fullDescription": "The International Telecommunication Union considers broadband to be any dedicated connection to the Internet of 256 kilobits per second or faster, in both directions. Broadband subscribers refers to the sum of DSL, cable modem and other broadband (for example, fiber optic, fixed wireless, apartment LANs, satellite connections) subscribers.",
		"GETR2016Number": "6.03"
	},
	"TFA Article 11": {
		"descriptionQuestion": "Freedom of transit",
		"dataType": "HARD",
		"globalId": "TFA Article 11",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 11 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"inv_community": {
		"descriptionQuestion": "Consultations with traders",
		"dataType": "HARD",
		"globalId": "inv_community",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Involvement of the trade community (0–2)",
		"shortTitle": "Involvement of the trade community",
		"otherShortTitle": "Involvement of the trade community",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Involvement of the trade community (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TFA Article 8": {
		"descriptionQuestion": "Border agency cooperation",
		"dataType": "HARD",
		"globalId": "TFA Article 8",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 8 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"CLEAREFF": {
		"descriptionQuestion": "Efficiency of the clearance process by customs and border control agencies (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "CLEAREFF",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Efficiency of the clearance process (1–5)",
		"shortTitle": "Efficiency of the clearance process",
		"otherShortTitle": "Efficiency of the clearance process",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Efficiency of the clearance process (1–5)",
		"fullDescription": "This indicator assesses the effectiveness and efficiency of the clearance process by customs and other border control agencies in the eight major trading partners of each country. Respondents to the LPI survey were asked to evaluate the effectiveness and efficiency of clearance in the country in which they work, based on their experience in international logistics, on a 1-5 scale compared with generally accepted industry standards or practices.",
		"GETR2016Number": "3.02"
	},
	"TFA Article 1": {
		"descriptionQuestion": "Publication and availability of information",
		"dataType": "HARD",
		"globalId": "TFA Article 1",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 1 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TFA Article 2": {
		"descriptionQuestion": "Opportunity to comment, information before entry into force and consultations",
		"dataType": "HARD",
		"globalId": "TFA Article 2",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 2 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"DBENFORCECONTRACTS": {
		"descriptionQuestion": "Enforcing contracts: efficiency and quality of commercial dispute resolution (0 = worst, 100 = best)",
		"dataType": "HARD",
		"globalId": "DBENFORCECONTRACTS",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			0
		],
		"sources": "The World Bank, [i]Doing Business Enforcing Contracts[i] ",
		"title": "Enforcing contract (0–100)",
		"shortTitle": "Enforcing contracts",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_INSTITQUALITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Enforcing contract (0–100)",
		"fullDescription": "The index is the result of the aggregation, with equal weighting, of three elements: number of days to resolve a commercial sale dispute through the courts; attorney, court and enforcement costs as a percentage of the claim value; and overall quality of judicial processes as measured through the application of good practices to promote quality and efficiency of the judicial system (in particular, this assesses the court structure and proceedings, case management practices, level of cour automation, and alternative dispute resolution framework). For more details about the methodology employed and the assumptions made to compute this indicator, visit http://www.doingbusiness.org/Methodology/Enforcing-Contracts",
		"GETR2016Number": "7.02.a"
	},
	"adv_rulings": {
		"descriptionQuestion": "Prior statements by the administration to requesting traders concerning the classification, origin, valuation method, etc., applied to specific goods at the time of importation; the rules and process applied to such statements",
		"dataType": "HARD",
		"globalId": "adv_rulings",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Advance rulings (0–2)",
		"shortTitle": "Advance rulings",
		"otherShortTitle": "Advance rulings",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Advance rulings (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"SUN-TABCOSTEXPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTEXPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Documentary compliance (1-7)",
		"shortTitle": "Cost to export: Documentary compliance",
		"otherShortTitle": "Cost to export: Documentary compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Documentary compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.09"
	},
	"form_proc": {
		"descriptionQuestion": "Streamlining of border controls; single submission points for all required documentation (single windows); post-clearance audits; authorised economic operators",
		"dataType": "HARD",
		"globalId": "form_proc",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Formalities - procedures (0–2)",
		"shortTitle": "Formalities - procedures",
		"otherShortTitle": "Formalities - procedures",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Formalities - procedures (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"NETUSERPCT": {
		"descriptionQuestion": "Percentage of individuals using the Internet",
		"dataType": "HARD",
		"globalId": "NETUSERPCT",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Individuals using Internet (%)",
		"shortTitle": "Internet users",
		"otherShortTitle": "Internet users",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Individuals using Internet (%)",
		"fullDescription": "Internet users are people with access to the worldwide network.",
		"GETR2016Number": "6.02"
	},
	"ETIC0401": {
		"descriptionQuestion": "Availability and quality of air transport infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0401",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of air transport infrastructure (1–7)",
		"shortTitle": "Availability and quality of air transport infrastructure",
		"otherShortTitle": "Availability and quality of air transport infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of air transport infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.01"
	},
	"EOSQ061": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for air transport (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ061",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.05,
			6.92
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of air transport infrastructure (1–7)",
		"shortTitle": "Quality of air transport infrastructure",
		"otherShortTitle": "Quality of air transport infrastructure",
		"parentCategoryGlobalId": "ETI.C.04.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of air transport infrastructure*",
		"fullDescription": "",
		"GETR2016Number": "4.02"
	},
	"ETIC04": {
		"descriptionQuestion": "Pillar 4: Availability and quality of transport infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC04",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of transport infrastructure (1–7)",
		"shortTitle": "Pillar 4: Availability and quality of transport infrastructure",
		"otherShortTitle": "Availability & quality of transport infrastructure",
		"parentCategoryGlobalId": "ETI.C",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 4: Availability and quality of transport infrastructure (1-7)",
		"fullDescription": "This pillar measures the availability and quality of domestic infrastructure for each of the four main modes of transport: road, air, railroad and seaport infrastructures. Air connectivity and sea line connectivity are also assessed.",
		"GETR2016Number": "C.04"
	},
	"ETIA01": {
		"descriptionQuestion": "Pillar 1: Domestic market access",
		"dataType": "AGGREG",
		"globalId": "ETIA01",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Domestic market access (1–7)",
		"shortTitle": "Pillar 1: Domestic market access",
		"otherShortTitle": "Domestic market access",
		"parentCategoryGlobalId": "ETI.A",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 1: Domestic market access (1–7)",
		"fullDescription": "This pillar assesses the level and complexity of a country’s tariff protection as a result of its trade policy. This component includes the effective trade-weighted average tariff applied by a country, the share of goods imported duty free and the complexity of the tariff regime, measured through tariff variance, the prevalence of tariff peaks and specific tariffs, and the number of distinct tariffs",
		"GETR2016Number": "A.01"
	},
	"appeal_proc": {
		"descriptionQuestion": "The possibility and modalities to appeal administrative decisions by border agencies",
		"dataType": "HARD",
		"globalId": "appeal_proc",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Appeal procedures (0–2)",
		"shortTitle": "Appeal procedures",
		"otherShortTitle": "Appeal procedures",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Appeal procedures (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EXPTIMECOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "EXPTIMECOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Time for documentary and border compliance for exporting (hours)",
		"shortTitle": "Time for documentary and border compliance for exporting",
		"otherShortTitle": "Time to comply with documentary and border compliance for exporting",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Time for documentary and border compliance for exporting (hours)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"TARIFNUMB": {
		"descriptionQuestion": "Number of distinct tariffs for all sectors",
		"dataType": "HARD",
		"globalId": "TARIFNUMB",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			6710
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Number of distinct tariffs",
		"shortTitle": "Number of distinct tariffs",
		"otherShortTitle": "Number of distinct tariffs",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Number of distinct tariffs",
		"fullDescription": "This indicator reflects the number of distinct tariff rates applied by a country to its imports across all sectors.",
		"GETR2016Number": "1.02.d"
	},
	"IMPTIMECOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "IMPTIMECOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Time for documentary & border compliance for importing (hours)",
		"shortTitle": "Time for documentary & border compliance for importing",
		"otherShortTitle": "Time to comply with documentary and border compliance for importing",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Time for documentary & border compliance for importing (hours)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"TFA Article 9": {
		"descriptionQuestion": "Movement of goods intended for import under customs control",
		"dataType": "HARD",
		"globalId": "TFA Article 9",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 9 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ058": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for railroads (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ058",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.1,
			6.8
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of railroad infrastructure (1–7)",
		"shortTitle": "Quality of railroad infrastructure",
		"otherShortTitle": "Quality of railroad infrastructure",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of railroad infrastructure, 1–7 (best) (all countries)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"EOSQ394": {
		"descriptionQuestion": "In your country, how efficient is the postal system? (1 = not efficient at all; 7 = extremely efficient)",
		"dataType": "SURVEY",
		"globalId": "EOSQ394",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.19,
			6.77
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2013 and 2014 editions",
		"title": "Postal services efficiency (1–7)",
		"shortTitle": "Postal service efficiency",
		"otherShortTitle": "Postal service efficiency",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Postal services efficiency*",
		"fullDescription": "",
		"GETR2016Number": "5.05"
	},
	"EXPCOSTCOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "EXPCOSTCOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Cost for documentary and border compliance for exporting (USD)",
		"shortTitle": "Cost for documentary and border compliance for exporting",
		"otherShortTitle": "Cost to comply with documentary and border compliance for exporting",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Cost for documentary and border compliance for exporting (USD)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"SHAREDUTYFREE": {
		"descriptionQuestion": "Duty-free imports as a share of total imports (%)",
		"dataType": "HARD",
		"globalId": "SHAREDUTYFREE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Share of duty-free imports (%)",
		"shortTitle": "Share of duty-free imports",
		"otherShortTitle": "Share of duty-free imports",
		"parentCategoryGlobalId": "ETI.A.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Share of duty-free imports (%)",
		"fullDescription": "Share of trade, excluding petroleum, that is imported free of tariff duties, taking into account MFN tariffs and preferential agreements. Tariff data is from 2015 or most recent year available and imports data is from 2014.",
		"GETR2016Number": "1.03"
	},
	"fees_charges": {
		"descriptionQuestion": "Disciplines on the fees and charges imposed on imports and exports",
		"dataType": "HARD",
		"globalId": "fees_charges",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Fees and charges (0–2)",
		"shortTitle": "Fees and charges",
		"otherShortTitle": "Fees and charges",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Fees and charges (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ469": {
		"descriptionQuestion": "In your country, to what extent does the cost of financial services (e.g. insurance, loans, trade finance) impede business activity? (1 = impedes business to a great extent; 7 = not at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ469",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.77,
			5.81
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Affordability of financial services (1-7)",
		"shortTitle": "Affordability of financial services",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_FINANCE",
		"includedDashboard": "YES",
		"titleWithUnits": "Affordability of financial services*  ",
		"fullDescription": "",
		"GETR2016Number": "7.03.b"
	},
	"form_docs": {
		"descriptionQuestion": "Simplification of trade documents; harmonisation in accordance with international standards; acceptance of copies",
		"dataType": "HARD",
		"globalId": "form_docs",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Formalities - documents (0–2)",
		"shortTitle": "Formalities - documents",
		"otherShortTitle": "Formalities - documents",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Formalities - documents (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABTIMEIMPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABTIMEIMPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			588
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Border compliance (hours)",
		"shortTitle": "Time to import: Border compliance",
		"otherShortTitle": "Time to import: Border compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Border compliance (hours)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.04"
	},
	"ETIC0402": {
		"descriptionQuestion": "Availability and quality of railroad infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0402",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of railroad infrastructure (1–7)",
		"shortTitle": "Availability and quality of railroad infrastructure",
		"otherShortTitle": "Availability and quality of railroad infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of railroad infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.02"
	},
	"TERRORISMINCIDENCE": {
		"descriptionQuestion": "Simple average of the number of terrorism-related casualties (injuries and fatalities) and the number of terrorist attacks, each normalized on a scale of 1 to 7",
		"dataType": "HARD",
		"globalId": "TERRORISMINCIDENCE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from National Consortium for the Study of Terrorism and Responses to Terrorism (START). Global Terrorism Database. Retrieved from http://www.start.umd.edu/gtd on 28 September 2016.",
		"title": "Index of terrorism incidence (1-7)",
		"shortTitle": "Terrorism incidence",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Index of terrorism incidence (1-7)",
		"fullDescription": "This index has been created on the basis of data contained in the START Database (National Consortium for the Study of Terrorism and Responses to Terrorism). It is the average of the three-year (2013-2015) total number of “terrorism attacks” and “terrorism casualties” (fatalities plus injured people) normalized according to the min-max methodology, with the maximum value corresponding to the 95th percentile of each of the two datasets. ",
		"GETR2016Number": "7.05.e"
	},
	"EOSQ034": {
		"descriptionQuestion": "In your country, to what extent does the incidence of crime and violence impose costs on businesses? (1 = to a great extent, imposes huge costs; 7 = no costs at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ034",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.59,
			6.8
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Business costs of crime and violence (1-7)",
		"shortTitle": "Business costs of crime and violence",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Business costs of crime and violence*",
		"fullDescription": "",
		"GETR2016Number": "7.05.b"
	},
	"EOSQ048": {
		"descriptionQuestion": "In your country, how burdensome is it for companies to comply with public administration’s requirements (e.g. permits, regulations, reporting)? (1 = extremely burdensome; 7 = not burdensome at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ048",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.32,
			5.66
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Ease of compliance with government regulation (1-7)",
		"shortTitle": "Burden of government regulation",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_INSTITQUALITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease of compliance with government regulation*",
		"fullDescription": "",
		"GETR2016Number": "7.02.c"
	},
	"EOSQ055": {
		"descriptionQuestion": "In your country, to what extent can police services be relied upon to enforce law and order? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ055",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.73,
			6.79
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Reliability of police services (1-7)",
		"shortTitle": "Reliability of police services",
		"otherShortTitle": "Reliability of police services",
		"parentCategoryGlobalId": "ETI_SECURITY",
		"includedDashboard": "YES",
		"titleWithUnits": "Reliability of police services*",
		"fullDescription": "",
		"GETR2016Number": "7.05.a"
	},
	"EOSQ147": {
		"descriptionQuestion": "In your country, how common is it for companies to make undocumented extra payments or bribes in connection with imports and exports (1 = very common; 7 = never occurs)",
		"dataType": "SURVEY",
		"globalId": "EOSQ147",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.56,
			6.83
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Irregular payments in exports and imports (1–7)",
		"shortTitle": "Irregular payments in exports and imports",
		"otherShortTitle": "Irregular payments in exports and imports",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Irregular payments in exports and imports*",
		"fullDescription": "",
		"GETR2016Number": "3.11"
	},
	"SUN-CLEAREFF": {
		"descriptionQuestion": "Efficiency of the clearance process by customs and border control agencies (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-CLEAREFF",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Efficiency of the clearance process (1–7)",
		"shortTitle": "Efficiency of the clearance process",
		"otherShortTitle": "Efficiency of the clearance process",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Efficiency of the clearance process (1-7)",
		"fullDescription": "This indicator assesses the effectiveness and efficiency of the clearance process by customs and other border control agencies in the eight major trading partners of each country. Respondents to the LPI survey were asked to evaluate the effectiveness and efficiency of clearance in the country in which they work, based on their experience in international logistics, on a 1-7 scale compared with generally accepted industry standards or practices.",
		"GETR2016Number": "3.02"
	},
	"SUN-TABTIMEIMPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEIMPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Border compliance (1-7)",
		"shortTitle": "Time to import: Border compliance",
		"otherShortTitle": "Time to import: Border compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Border compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.04"
	},
	"SUN-TABTIMEEXPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEEXPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Documentary compliance (1-7)",
		"shortTitle": "Time to export: Documentary compliance",
		"otherShortTitle": "Time to export: Documentary compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Documentary compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.07"
	},
	"OPENMULTRDRULE": {
		"descriptionQuestion": "Index of openness to multilateral trade rules (0 = lowest, 100 = highest)",
		"dataType": "HARD",
		"globalId": "OPENMULTRDRULE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			0
		],
		"sources": "International Trade Centre, based on data from the Trade Treaties map - LegaCarta database",
		"title": "Openness to multilateral trade rules (0–100)",
		"shortTitle": "Openness to multilateral trade rules",
		"otherShortTitle": "Openness to multilateral trade rules",
		"parentCategoryGlobalId": "ETI_OPENFRXPART",
		"includedDashboard": "YES",
		"titleWithUnits": "Openness to multilateral trade rules (0–100)",
		"fullDescription": "This index evaluates the overall participation of countries in multilateral trade rules or instruments (MTRs). These rules are all internationally elaborated legal standards currently regulating trade in specific areas. MTRs are primarily comprised of conventions and treaties that countries ratify or accede to, and international model laws that are incorporated into national law. The index is based on ITC’s Trade Treaties map - LegaCarta system, which analyzes the position of each country (accession/nonaccession and incorporation/nonincorporation) regarding some 280 MTRs as well as 450 protocols or amendments overseen by 28 different international organizations. For the purposes of this index, 40 core MTRs were selected, and each was rated with a score depending on its importance and relevance to trade. The 40 core instruments belong to seven categories (contracts, customs, dispute resolution, governance, intellectual property, investment and air transport). Each category is given an equal weight in the calculation of the index. Selection of the core instruments is based on their importance and relevance to trade and their universality. The importance and relevance to trade of an instrument is determined by taking into account several criteria including: the impact of its provisions on international trade (reduction of transactional costs, trade facilitation, harmonization, transparency, predictability, creation of a business-friendly business climate, support of private-sector activities and encouragement of foreign direct investment), the opinion of international legal experts and the views of the international bodies administering these instruments. Universality means that the selected MTRs can potentially be applied by all countries, notwithstanding their geographical position or economic level. For example, maritime transport conventions, however important, were not taken into account because of their weak relevance for landlocked countries; treaties dealing with securities and insider trading were not included because they do not represent a priority in countries that have not developed sophisticated financial markets. Accession to the WTO Agreements is not taken into account in this index as WTO accession does not depend exclusively on the will of a non-member state to join the WTO.",
		"GETR2016Number": "7.04.c"
	},
	"SUN-TABCOSTEXPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTEXPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Border compliance (1-7)",
		"shortTitle": "Cost to export: Border compliance",
		"otherShortTitle": "Cost to export: Border compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Border compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.10"
	},
	"EOSQ095": {
		"descriptionQuestion": "In your country, how restrictive are rules and regulations on foreign direct investment (FDI)? (1 = extremely restrictive; 7 = not restrictive at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ095",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.41,
			6.68
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Business impact of rules on FDI (1-7)",
		"shortTitle": "Business impact of rules on FDI",
		"otherShortTitle": "Business impact of rules on FDI",
		"parentCategoryGlobalId": "ETI_OPENFRXPART",
		"includedDashboard": "YES",
		"titleWithUnits": "Business impact of rules on FDI*",
		"fullDescription": "",
		"GETR2016Number": "7.04.b"
	},
	"gov_impartiality": {
		"descriptionQuestion": "Customs structures and functions; accountability; ethics policy",
		"dataType": "HARD",
		"globalId": "gov_impartiality",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Governance and impartiality (0–2)",
		"shortTitle": "Governance and impartiality",
		"otherShortTitle": "Governance and impartiality",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Governance and impartiality (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABTIMEEXPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABTIMEEXPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0.5,
			698
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Documentary compliance (hours)",
		"shortTitle": "Time to export: Documentary compliance",
		"otherShortTitle": "Time to export: Documentary compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Documentary compliance (hours)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.07"
	},
	"ETI_INSTITQUALITY": {
		"descriptionQuestion": "Index of efficiency and accountability of public institutions (1 = worst, 7 = best)",
		"dataType": "AGGREG",
		"globalId": "ETI_INSTITQUALITY",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from World Economic Forum and World Bank.",
		"title": "Efficiency and accountability of public institutions (1–7)",
		"shortTitle": "Efficiency and accountability of public institutions",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Efficiency and accountability of public institutions index (1–7)",
		"fullDescription": "This indicator is a combination of three indicators derived from the World Bank's [i]Doing Business Database[i] and the World Economic Forum's [i]Executive Opinion Survey[i]: Enforcing contracts; Diversion of public funds and Burden of government regulation. See description of each individual indicator for more details.",
		"GETR2016Number": "7.02"
	},
	"EOSQ052": {
		"descriptionQuestion": "In your country, to what extent is intellectual property protected? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ052",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.57,
			6.48
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Intellectual property protection (1-7)",
		"shortTitle": "Intellectual property protection",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_PROPERTYPROTECT",
		"includedDashboard": "YES",
		"titleWithUnits": "Intellectual property protection*",
		"fullDescription": "",
		"GETR2016Number": "7.01.b"
	},
	"ext_cooperation": {
		"descriptionQuestion": "Co-operation with neighbouring and third countries",
		"dataType": "HARD",
		"globalId": "ext_cooperation",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Border agency cooperation - external (0–2)",
		"shortTitle": "Border agency cooperation - external",
		"otherShortTitle": "Border agency cooperation - external",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Border agency cooperation - external (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TARIFDISP": {
		"descriptionQuestion": "Standard deviation of applied tariff rates",
		"dataType": "HARD",
		"globalId": "TARIFDISP",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			143.99
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariff dispersion (standard deviation)",
		"shortTitle": "Tariff dispersion",
		"otherShortTitle": "Tariff dispersion",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariff dispersion (standard deviation)",
		"fullDescription": "This indicator reflects differences in tariffs across product categories in a country’s tariff structure. The variance is calculated across all the tariffs on imported merchandise goods, at the 6-digit level of the Harmonized Schedule.",
		"GETR2016Number": "1.02.a"
	},
	"ETIB": {
		"descriptionQuestion": "Subindex B: Border administration",
		"dataType": "AGGREG",
		"globalId": "ETIB",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Border administration (1–7)",
		"shortTitle": "Border Administration: overall indicator",
		"otherShortTitle": "Border administration",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex B: Border administration (1–7)",
		"fullDescription": "This sub-index assesses the efficiency and transparency of border administration. More specifically, it captures efficiency, transparency and costs associated with importing and exporting goods. It includes an assessment of the range, quality and comprehensiveness of key services offered by customs and related agencies, and the average time, costs and number of documents required to, respectively, import and export goods. The pillar also assesses the time predictability of border procedures, as well as the transparency of the process—as measured by the availability and quality of information provided by border agencies—and the prevalence of corruption",
		"GETR2016Number": "B"
	},
	"TRACKTRACE": {
		"descriptionQuestion": "Ability to track and trace consignments (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "TRACKTRACE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Tracking and tracing ability (1–5)",
		"shortTitle": "Tracking and tracing ability",
		"otherShortTitle": "Tracking and tracing ability",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Tracking and tracing ability (1–5)",
		"fullDescription": "This indicator assesses the ability to track and trace international shipments (consignments). Respondents to the LPI survey were asked to evaluate the ability to track and trace international shipments (consignments) when shipping to or from eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.03"
	},
	"TARIFPEAK": {
		"descriptionQuestion": "Share of tariff lines with domestic peaks (%)",
		"dataType": "HARD",
		"globalId": "TARIFPEAK",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariff peaks (% of tariff lines)",
		"shortTitle": "Tariff peaks",
		"otherShortTitle": "Tariff peaks",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariff peaks (% of tariff lines)",
		"fullDescription": "This indicator is the ratio of the number of tariff lines exceeding three times the average domestic tariff (across all products) to the MFN (most-favoured nation) tariff schedule. The tariff schedule is equal to the total number of tariff lines for each country. These tariffs are revised on a yearly basis.",
		"GETR2016Number": "1.02.b"
	},
	"TFA Article 5": {
		"descriptionQuestion": "Other measures to enhance impartiality, non-discrimination and transparency",
		"dataType": "HARD",
		"globalId": "TFA Article 5",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 5 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"LOGICOMP": {
		"descriptionQuestion": "Competence and quality of logistics services, e.g. transport operators and customs brokers (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "LOGICOMP",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Logistics competence (1–5)",
		"shortTitle": "Logistics competence",
		"otherShortTitle": "Logistics competence",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Logistics competence (1–5)",
		"fullDescription": "This indicator evaluates the competence of the local logistics industry. Respondents to the LPI survey were asked to evaluate the competence of the local logistics industry in the eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.02"
	},
	"GOVONLINESERVIDX": {
		"descriptionQuestion": "The Government Online Service Index assesses the quality of government’s delivery of online services (0 = very low, 1 = very high)",
		"dataType": "HARD",
		"globalId": "GOVONLINESERVIDX",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1
		],
		"sources": "United Nations, [i]UN E-Government Survey 2016: E-Government in support of sustainable development[i]",
		"title": "Government Online Service Index (0–1)",
		"shortTitle": "Government Online Service Index",
		"otherShortTitle": "Government Online Service Index",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Government Online Service Index (0–1)",
		"fullDescription": "The Index captures a government’s performance in delivering online services to the citizens. There are four stages of service delivery (Emerging, Enhanced, Transactional and Connected). Online services are assigned to each stage according to their degree of sophistication, from the more basic to the more sophisticated. In each country, the performance of the government in each of the four stages is measured as the number of services provided as a percentage of the maximum services in the corresponding stage. Examples of services include online presence, deployment of multimedia content, governments’ solicitation of citizen input, widespread data sharing and use of social networking. For more details about the methodology employed and the assumptions made to compute this indicator, please consult the UN’s Global E-Government Survey 2012’s dedicated page at http://www2.unpan.org/egovkb/global_reports/12report.htm.",
		"GETR2016Number": "6.07"
	},
	"EOSQ088": {
		"descriptionQuestion": "In your country, how easy is it for businesses to obtain a bank loan? (1 = extremely difficult; 7 = extremely easy)",
		"dataType": "SURVEY",
		"globalId": "EOSQ088",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.25,
			5.74
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Ease of access to loans (1-7)",
		"shortTitle": "Ease of access to loans",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_FINANCE",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease of access to loans*",
		"fullDescription": "",
		"GETR2016Number": "7.03.c"
	},
	"inf_availability": {
		"descriptionQuestion": "Publication of trade information, including on internet; enquiry points",
		"dataType": "HARD",
		"globalId": "inf_availability",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Information availability (0–2)",
		"shortTitle": "Information availability",
		"otherShortTitle": "Information availability",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Information availability (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TARIFACED": {
		"descriptionQuestion": "Trade-weighted average tariff faced in destination markets (%)",
		"dataType": "HARD",
		"globalId": "TARIFACED",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Tariffs faced (%)",
		"shortTitle": "Tariffs faced",
		"otherShortTitle": "Tariffs faced",
		"parentCategoryGlobalId": "ETI.A.02",
		"includedDashboard": "YES",
		"titleWithUnits": "Tariffs faced (%)",
		"fullDescription": "This indicator is calculated as the trade-weighted average of the applied tariff rates, including preferential rates that the rest of the world applies to each country. The weights are the trade patterns of the importing country's reference group (2014 trade data). The reference year for tariffs changes according to the destination market. The majority of countries reports 2015 tariff data. A tariff is a customs duty that is levied by the destination country on imports of merchandise goods.",
		"GETR2016Number": "2.01"
	},
	"ETIA": {
		"descriptionQuestion": "Subindex A: Market access",
		"dataType": "AGGREG",
		"globalId": "ETIA",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Market access (1–7)",
		"shortTitle": "Subindex A: Market access",
		"otherShortTitle": "Market access",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex A: Market access (1–7)",
		"fullDescription": "This subindex measures the extent and complexity of a country’s tariff regime, as well as tariff barriers faced and preferences enjoyed by a country’s exporters in foreign markets",
		"GETR2016Number": "A"
	},
	"ROADQUALIDX": {
		"descriptionQuestion": "Average speed and straightness of a driving itinerary connecting the 10 or more largest cities that together account for at least 15 percent of the economy's total population (1 = worst, 7 = best).",
		"dataType": "HARD",
		"globalId": "ROADQUALIDX",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations",
		"title": "Road Quality Index (1–7)",
		"shortTitle": "Road Quality Index",
		"otherShortTitle": "Road Quality Index",
		"parentCategoryGlobalId": "ETI.C.04.04",
		"includedDashboard": "YES",
		"titleWithUnits": "Road Quality Index (1–7)",
		"fullDescription": "The Road Quality Index developed by the World Economic Forum comprises two elements: a measure of the average speed of a driving itinerary connecting the 10 or more largest cities in an economy accounting for at least 15 percent of the economy’s total population; and a measure of road straightness.The itinerary was not optimized and connects the cities from the largest to the smallest. Any leg involving a ferry is excluded from the average speed calculation. As a first step to the identification of cities to include in the itinerary. pairwise distances (“ as the crow flies” ) were calculated, and when the distance was less than 20 kilometers, the smallest city in the pair was excluded. The road straightness corresponds to the ratio of the sum of driving distances between each city in the journey to the sum of crow fly distances between each city in the journey. For this component, legs involving a ferry were included. The APIs of Google Directions and Open Street Map were used to compute the itinerary. The Geonames database was used for city populations and coordinates. For more information about this indicator, email tge@weforum.org.",
		"GETR2016Number": "4.06"
	},
	"ETI_PROPERTYPROTECT": {
		"descriptionQuestion": "Index of protection of property (1 = extremely weak, 7 = extremely strong)",
		"dataType": "AGGREG",
		"globalId": "ETI_PROPERTYPROTECT",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Protection of property (1–7)",
		"shortTitle": "Protection of property",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Protection of property index (1–7)",
		"fullDescription": "This indicator is a combination of two indicators derived from the World Economic Forum's [i]Executive Opinion Survey[i]: Protection of property rights and Intellectual property protection. See description of each individual indicator for more details.",
		"GETR2016Number": "7.01"
	},
	"SUN-TABCOSTIMPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTIMPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Documentary compliance (1-7)",
		"shortTitle": "Cost to import: Documentary compliance",
		"otherShortTitle": "Cost to import: Documentary compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Documentary compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.05"
	},
	"TABCOSTEXPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABCOSTEXPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			2223
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Border compliance (US$)",
		"shortTitle": "Cost to export: Border compliance",
		"otherShortTitle": "Cost to export: Border compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Border compliance (US$)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.1"
	},
	"SUN-CUSTTRANSPIND": {
		"descriptionQuestion": "Index of transparency of procedures and regulations related to customs clearance (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-CUSTTRANSPIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association",
		"title": "Customs transparency index (1-7)",
		"shortTitle": "Customs transparency index",
		"otherShortTitle": "Customs transparency index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs transparency index (1-7)",
		"fullDescription": "This indicator is based on 7 survey questions taken from the GEA Customs Capabilities Reports, evaluating the overall transparency of the procedures and regulations related to customs clearance. The maximum score an economy can obtain is 1.",
		"GETR2016Number": "3.13"
	},
	"TFA Article 4": {
		"descriptionQuestion": "Procedures for appeal or review",
		"dataType": "HARD",
		"globalId": "TFA Article 4",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 4 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABCOSTIMPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border. ",
		"dataType": "HARD",
		"globalId": "TABCOSTIMPBORD",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			3039
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Border compliance (US$)",
		"shortTitle": "Cost to import: Border compliance",
		"otherShortTitle": "Cost to import: Border compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Border compliance (US$)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.06"
	},
	"SUN-EOSQ147": {
		"descriptionQuestion": "In your country, how common is it for companies to make undocumented extra payments or bribes in connection with imports and exports  (1 = very low, 7  = very high)",
		"dataType": "SURVEY",
		"globalId": "SUN-EOSQ147",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Irregular payments in exports and imports (1–7)",
		"shortTitle": "Irregular payments in exports and imports",
		"otherShortTitle": "Irregular payments in exports and imports",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Irregular payments in exports and imports (1-7)",
		"fullDescription": "",
		"GETR2016Number": "3.11"
	},
	"TARIFCOMPL": {
		"descriptionQuestion": "Index of complexity of tariffs, 1–7 (least complex) scale",
		"dataType": "AGGREG",
		"globalId": "TARIFCOMPL",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Complexity of tariffs index (1–7)",
		"shortTitle": "Complexity of tariffs",
		"otherShortTitle": "Complexity of tariffs",
		"parentCategoryGlobalId": "ETI.A.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Complexity of tariffs index (1–7)",
		"fullDescription": "This indicator is calculated as the average of the following indicators: Tariff dispersion, Specific tariffs and Number of distinct tariffs. See description of each individual indicator for more details. Prior to averaging, values for each indicator were transformed to a 1-to-7 score, using the min-max method.",
		"GETR2016Number": "1.02"
	},
	"RAILROADQUALITY": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for railroads (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "RAILROADQUALITY",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.18,
			6.72
		],
		"sources": "World Economic Forum,[i] Executive Opinion Survey[i], 2015 and 2016 editions\n[6]Note: N/Appl. is used for economies where the railroad network totals less than 50 km.",
		"title": "Quality of railroad infrastructure (1–7)",
		"shortTitle": "Quality of railroad infrastructure",
		"otherShortTitle": "Quality of railroad infrastructure",
		"parentCategoryGlobalId": "ETI.C.04.02",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of railroad infrastructure*",
		"fullDescription": "N/Appl. is used for economies where the railroad network totals less than 50 km. Assessment of the existence of a network was conducted by the World Economic Forum based on various sources.",
		"GETR2016Number": "4.03"
	},
	"EOSQ360": {
		"descriptionQuestion": "In your country, how efficient are changes between different modes of transport for cargo (e.g. from port to rail or airport to roads)? (1 = extremely inefficient; 7 = extremely efficient)",
		"dataType": "SURVEY",
		"globalId": "EOSQ360",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.55,
			6.54
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Efficiency of transport mode change (1–7)",
		"shortTitle": "Efficiency of transport mode change",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Efficiency of transport mode change*",
		"fullDescription": "",
		"GETR2016Number": "5.06"
	},
	"ETIC06": {
		"descriptionQuestion": "Pillar 6: Availability and use of ICTs",
		"dataType": "AGGREG",
		"globalId": "ETIC06",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and use of ICTs (1–7)",
		"shortTitle": "Pillar 6: Availability and use of ICTs",
		"otherShortTitle": "Availability & use of ICTs",
		"parentCategoryGlobalId": "ETI.C",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 6: Availability and use of ICTs (1–7)",
		"fullDescription": "This pillar evaluates the availability and quality of information and communication technologies (ICTs) in a country, as approximated by the use of mobile telephony and Internet by the population at large, by companies for business transactions, and by the government for interacting with citizens. It also takes into account the quality of internet access, as broadband access has become the norm, to fully leverage the potential of the internet",
		"GETR2016Number": "C.06"
	},
	"ETIC0404": {
		"descriptionQuestion": "Availability and quality of road infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0404",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of road infrastructure (1–7)",
		"shortTitle": "Availability and quality of road infrastructure",
		"otherShortTitle": "Availability and quality of road infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of road infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.04"
	},
	"ETIC": {
		"descriptionQuestion": "Subindex C: Infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Infrastructure (1–7)",
		"shortTitle": "Subindex C: Infrastructure",
		"otherShortTitle": "Infrastructure",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex C: Infrastructure (1–7)",
		"fullDescription": "This subindex assesses the availability and quality of transport infrastructure of a country, associated services, and communication infrastructure, necessary to facilitate the movement of goods within the country and across the border",
		"GETR2016Number": "C"
	},
	"MARGINPREF": {
		"descriptionQuestion": "Index of margin of preference in destination markets, 0–100 (best)",
		"dataType": "HARD",
		"globalId": "MARGINPREF",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			0
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Index of margin of preference in destination markets (0–100)",
		"shortTitle": "Margin of preference in destination markets",
		"otherShortTitle": "Margin of preference in destination markets",
		"parentCategoryGlobalId": "ETI.A.02",
		"includedDashboard": "YES",
		"titleWithUnits": "Index of margin of preference in destination mkts (0–100)",
		"fullDescription": "This indicator measures the percentage by which particular imports from one country are subject to lower tariffs than the MFN rate. It is calculated as the average of two components: 1) the trade-weighted average difference between the MFN tariff and the most advantageous preferential duty (advantage score), and 2) the ratio of the advantage score to the trade-weighted average MFN tariff level. This allows capturing both the absolute and the relative margin of preference.  The reference year for tariffs changes according to the destination market. The majority of countries reports 2015 tariff data",
		"GETR2016Number": "2.02"
	},
	"form_auto": {
		"descriptionQuestion": "Electronic exchange of data; automated border procedures; use of risk management",
		"dataType": "HARD",
		"globalId": "form_auto",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "OECD Trade Facilitation Indicators",
		"domain": [
			0,
			2
		],
		"sources": "Organization for Economic Cooperation and Development (OECD); Trade Facilitation Indicators",
		"title": "Formalities - automation (0–2)",
		"shortTitle": "Formalities - automation",
		"otherShortTitle": "Formalities - automation",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Formalities - automation (0-2)",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"ETI": {
		"descriptionQuestion": "Enabling Trade Index",
		"dataType": "AGGREG",
		"globalId": "ETI",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Enabling trade Index (1–7)",
		"shortTitle": "Enabling Trade Index",
		"otherShortTitle": "Enabling Trade Index",
		"parentCategoryGlobalId": "N/Appl.",
		"includedDashboard": "YES",
		"titleWithUnits": "Enabling Trade Index (1–7)",
		"fullDescription": "The Enabling Trade Index assesses the extent to which economies have in place institutions, policies, infrastructures and services facilitating the free flow of goods over borders and to their destination",
		"GETR2016Number": "ETI"
	},
	"ETIC05": {
		"descriptionQuestion": "Pillar 5: Availability and quality of transport services",
		"dataType": "AGGREG",
		"globalId": "ETIC05",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of transport services (1–7)",
		"shortTitle": "Pillar 5: Availability and quality of transport services",
		"otherShortTitle": "Availability & quality of transport services",
		"parentCategoryGlobalId": "ETI.C",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 5: Availability and quality of transport services (1–7)",
		"fullDescription": "A necessary complement to the previous one, this pillar assesses the availability and quality of transport services, including the presence and competencies of shipping and logistics companies in the country, as well as the ease, cost and timeliness of shipment. In addition, this pillar includes a measure of postal efficiency",
		"GETR2016Number": "C.05"
	},
	"CUSTTRANSPIND": {
		"descriptionQuestion": "Index of transparency of procedures and regulations related to customs clearance (0 = worst, 1 = best)",
		"dataType": "HARD",
		"globalId": "CUSTTRANSPIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association",
		"title": "Customs transparency index (0–1)",
		"shortTitle": "Customs transparency index",
		"otherShortTitle": "Customs transparency index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs transparency index (0–1)",
		"fullDescription": "This indicator is based on 7 survey questions taken from the GEA Customs Capabilities Reports, evaluating the overall transparency of the procedures and regulations related to customs clearance. The maximum score an economy can obtain is 1.",
		"GETR2016Number": "3.13"
	},
	"INTLAIRSEATKM": {
		"descriptionQuestion": "Scheduled available international airline seat kilometres per week originating in country (in millions)",
		"dataType": "HARD",
		"globalId": "INTLAIRSEATKM",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0.25,
			13928.58
		],
		"sources": "International Air Transport Association, SRS Analyser",
		"title": "Available international airline seat km/week, millions",
		"shortTitle": "Available airline seat kilometres",
		"otherShortTitle": "Available airline seat kilometers",
		"parentCategoryGlobalId": "ETI.C.04.01",
		"includedDashboard": "YES",
		"titleWithUnits": "Available int'l airline seat km/week, millions",
		"fullDescription": "This variable measures the total passenger-carrying capacity of all scheduled international flights originating in a country. It is computed by taking the number of seats available on each flight multiplied by the flight distance in kilometres, summing the result across all scheduled flights in a week during January (winter schedule) and July (summer schedule) 2013, and taking the average capacity of the two weeks.",
		"GETR2016Number": "4.01"
	},
	"EOSQ138": {
		"descriptionQuestion": "In your country, how restrictive are regulations related to the hiring of foreign labor? (1 = highly restrictive; 7 = not restrictive at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ138",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.05,
			6.18
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Ease of hiring foreign labour (1-7)",
		"shortTitle": "Ease of hiring foreign labour",
		"otherShortTitle": "Ease of hiring foreign labour",
		"parentCategoryGlobalId": "ETI_OPENFRXPART",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease of hiring foreign labour*",
		"fullDescription": "",
		"GETR2016Number": "7.04.a"
	},
	"ETI_FINANCE": {
		"descriptionQuestion": "Index of access to finance (1 = worst, 7 = best)",
		"dataType": "AGGREG",
		"globalId": "ETI_FINANCE",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Access to finance (1–7)",
		"shortTitle": "Access to finance",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Access to finance index (1–7) ",
		"fullDescription": "This indicator is a combination of three indicators derived from the World Economic Forum's [i]Executive Opinion Surve[i]y: Financial services meeting business needs, Affordability of financial services, Availability of financial services and Ease of access to loans. See description of each individual indicator for more details.",
		"GETR2016Number": "7.03"
	},
	"EOSQ057": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for foads (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ057",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.32,
			6.72
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of roads (1–7)",
		"shortTitle": "Quality of roads",
		"otherShortTitle": "Quality of roads",
		"parentCategoryGlobalId": "ETI.C.04.04",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of roads*",
		"fullDescription": "",
		"GETR2016Number": "4.07"
	},
	"ETID07": {
		"descriptionQuestion": "Pillar 7: Operating environment",
		"dataType": "AGGREG",
		"globalId": "ETID07",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Operating environment (1–7)",
		"shortTitle": "Pillar 7: Operating environment",
		"otherShortTitle": "Operating environment",
		"parentCategoryGlobalId": "ETI.D",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 7: Operating environment (1–7)",
		"fullDescription": "This pillar assesses the quality of a country’s operating environment, which significantly impacts the capacity of companies that export, import, trade and/or transport merchandise to do business. It assesses a country’s level of protection of property rights, the quality and impartiality of its public institutions, efficiency in enforcing contracts, the availability of finance, openness to foreign participation in terms of foreign investments and labour, as well as the level of personal security approximated by the incidence of crime and terrorism",
		"GETR2016Number": "D.07"
	},
	"TABCOSTEXPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABCOSTEXPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			2500
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to export: Documentary compliance (US$)",
		"shortTitle": "Cost to export: Documentary compliance",
		"otherShortTitle": "Cost to export: Documentary compliance (US$)",
		"parentCategoryGlobalId": "EXPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to export: Documentary compliance (US$)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.09"
	},
	"TIMESHIP": {
		"descriptionQuestion": "Frequency of shipments reaching the consignee within the scheduled delivery (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "TIMESHIP",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Timeliness of shipments in reaching destination (1–5)",
		"shortTitle": "Timeliness of shipments in reaching destination",
		"otherShortTitle": "Timeliness of shipments in reaching destination",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Timeliness of shipments in reaching destination (1–5)",
		"fullDescription": "This indicator assesses how often shipments reach the consignee within the scheduled delivery time. Respondents to the LPI survey were asked to evaluate the timeliness of shipments in reaching their destination when arranging shipments to eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.04"
	},
	"EOSQ365": {
		"descriptionQuestion": "In your country, to what extent do businesses use ICTs for transactions with other businesses? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ365",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.66,
			6.36
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "ICT use for business-to-business transactions (1–7)",
		"shortTitle": "ICT use for business-to-business transactions",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "ICT use for business-to-business transactions*",
		"fullDescription": "",
		"GETR2016Number": "6.05"
	},
	"EOSQ395": {
		"descriptionQuestion": "In your country, how much does the time required for border clearance of imported goods fluctuate? (1 = fluctuates significantly; 7 = hardly fluctuates at all)",
		"dataType": "SURVEY",
		"globalId": "EOSQ395",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.9,
			6.08
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Time predictability of import procedures (1–7)",
		"shortTitle": "Time predictability of import procedures",
		"otherShortTitle": "Time predictability of import procedures",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Time predictability of import procedures*",
		"fullDescription": "",
		"GETR2016Number": "3.12"
	},
	"SUN-CUSTSERVIND": {
		"descriptionQuestion": "Index of extent of quality and comprehensiveness of services provided by customs authorities and related agencies (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-CUSTSERVIND",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from Global Express Association (GEA) Customs Capabilities Database",
		"title": "Customs services index (1-7)",
		"shortTitle": "Customs services index",
		"otherShortTitle": "Customs services index",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Customs services index (1-7)",
		"fullDescription": "This indicator is based on 17 survey questions taken from the GEA Customs Capabilities Reports, which evaluate the quality and comprehensiveness of services offered by customs and related agencies. The services included: clearance of shipments via electronic data interchange; separation of physical release of goods from fiscal control; full-time (24 hours/7 days a week) automated processing; customs working hours adapted to commercial needs; fee for services conducted during normal service hours; inspection and release of goods arriving by air by the operator's facility; automated risk assessment as primary basis for physical examination of shipments; multiple inspections (inspections by agencies other than customs) and the promptness of those inspections; exemptions from full customs formalities for shipments of minimal value; exemptions from a duties and taxes for shipments of minimal value; clearance of shipments by a third party; appeal of customs decisions to a higher level or an independent tribunal; and use of reference prices or arbitrary uplifts to invoice values. The maximum score an economy can obtain is 7.",
		"GETR2016Number": "3.01"
	},
	"IMPCOSTCOMPLIANCEIDX": {
		"descriptionQuestion": "",
		"dataType": "HARD",
		"globalId": "IMPCOSTCOMPLIANCEIDX",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"sources": "",
		"title": "Cost for documentary and border compliance for importing (USD)",
		"shortTitle": "Cost for documentary and border compliance for importing",
		"otherShortTitle": "Cost to comply with documentary and border compliance for importing",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Cost for documentary and border compliance for importing (USD)",
		"fullDescription": "",
		"GETR2016Number": ""
	},
	"MOBSUBPC": {
		"descriptionQuestion": "Mobile telephone subscriptions (post-paid and pre-paid) per 100 population",
		"dataType": "HARD",
		"globalId": "MOBSUBPC",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			4151900
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Mobile phone subscriptions/100 pop.",
		"shortTitle": "Mobile telephone subscriptions",
		"otherShortTitle": "Mobile telephone subscriptions",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Mobile phone subscriptions/100 pop.",
		"fullDescription": "According to the World Bank, mobile cellular telephone subscriptions are subscriptions to a public mobile telephone service using cellular technology, which provides access to switched telephone technology. Postpaid and prepaid subscriptions are included. This can also include analogue and digital cellular systems but should not include non-cellular systems. Subscribers to fixed wireless, public mobile data services or radio paging services are not included.",
		"GETR2016Number": "6.01"
	},
	"MOBBBSUBPC": {
		"descriptionQuestion": "Active mobile broadband Internet subscriptions per 100 population",
		"dataType": "HARD",
		"globalId": "MOBBBSUBPC",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			291900
		],
		"sources": "International Telecommunication Union, [i]ITU World Telecommunication/ICT Indicators Database 2016[i] (June 2016 edition)",
		"title": "Active mobile broadband Internet subscriptions/100 pop.",
		"shortTitle": "Active mobile broadband subscriptions",
		"otherShortTitle": "Active mobile broadband subscriptions",
		"parentCategoryGlobalId": "ETI.C.06",
		"includedDashboard": "YES",
		"titleWithUnits": "Active mobile broadband Internet subscriptions/100 pop.",
		"fullDescription": "The International Telecommunication Union considers active mobile broadband internet subscriptions all “Standard mobile-broadband subscriptions (via a mobile-cellular telephone)” and “Dedicated mobile-broadband subscriptions (via UBS dongle/modem or as add-on data package to voice package”. Other wireless-broadband subscriptions, such as “Terrestrial fixed (wireless)-broadband subscriptions” (e.g. WiMAX) and “Satellite-broadband subscriptions”, are excluded from this indicator.",
		"GETR2016Number": "6.04"
	},
	"TFA Article 7": {
		"descriptionQuestion": "Release and clearance of goods",
		"dataType": "HARD",
		"globalId": "TFA Article 7",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 7 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"SHIPAFFORD": {
		"descriptionQuestion": "Ease of arranging competitively priced international shipments (1 = very low, 5 = very high)",
		"dataType": "HARD",
		"globalId": "SHIPAFFORD",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			5
		],
		"sources": "The World Bank, [i]Logistics Performance Index[i] ",
		"title": "Ease and affordability of shipment (1–5)",
		"shortTitle": "Ease and affordability of shipment",
		"otherShortTitle": "Ease and affordability of shipment",
		"parentCategoryGlobalId": "ETI.C.05",
		"includedDashboard": "YES",
		"titleWithUnits": "Ease and affordability of shipment (1–5)",
		"fullDescription": "This indicator assesses the ease and affordability associated with arranging international shipments. Respondents to the LPI survey were asked to evaluate the ease and affordability associated with arranging international shipments to or from eight countries (major trading partners) with which they conduct business. Performance was evaluated using a 5-point scale (1 for the lowest score, 5 for the highest), based on their experience in international logistics and in accordance with generally accepted industry standards or practices.",
		"GETR2016Number": "5.01"
	},
	"TFA Article 12": {
		"descriptionQuestion": "Customs cooperation",
		"dataType": "HARD",
		"globalId": "TFA Article 12",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 12 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"TABCOSTIMPDOC": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies.",
		"dataType": "HARD",
		"globalId": "TABCOSTIMPDOC",
		"rankDirection": "1",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			1025
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Documentary compliance (US$)",
		"shortTitle": "Cost to import: Documentary compliance",
		"otherShortTitle": "Cost to import: Documentary compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Documentary compliance (US$)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.05"
	},
	"SUN-TABCOSTIMPBORD": {
		"descriptionQuestion": "Cost (US$ per 15 metric tons) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABCOSTIMPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Cost to import: Border compliance (1-7)",
		"shortTitle": "Cost to import: Border compliance",
		"otherShortTitle": "Cost to import: Border compliance (US$)",
		"parentCategoryGlobalId": "IMPCOSTCOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Cost to import: Border compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.06"
	},
	"TARIFSPECIAL": {
		"descriptionQuestion": "Share of tariff lines with specific tariffs (%)",
		"dataType": "HARD",
		"globalId": "TARIFSPECIAL",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			0,
			100
		],
		"sources": "International Trade Centre, Market Access Map database, http://www.macmap.org/\n",
		"title": "Specific tariffs (% of tariff lines)",
		"shortTitle": "Specific tariffs",
		"otherShortTitle": "Specific tariffs",
		"parentCategoryGlobalId": "TARIFCOMPL",
		"includedDashboard": "YES",
		"titleWithUnits": "Specific tariffs (% of tariff lines)",
		"fullDescription": "This indicator is the ratio of the number of Harmonized System (HS) tariff lines, with at least one specific tariff, to the total number of HS tariff lines. A specific tariff is a tariff rate charged on fixed amount per quantity (as opposed to ad valorem).",
		"GETR2016Number": "1.02.c"
	},
	"SUN-EOSQ395": {
		"descriptionQuestion": "In your country, how much does the time required for border clearance of imported goods fluctuate?  (1 = very low, 7  = very high)",
		"dataType": "SURVEY",
		"globalId": "SUN-EOSQ395",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Time predictability of import procedures (1–7)",
		"shortTitle": "Time predictability of import procedures",
		"otherShortTitle": "Time predictability of import procedures",
		"parentCategoryGlobalId": "ETI.B.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Time predictability of import procedures (1-7)",
		"fullDescription": "",
		"GETR2016Number": "3.12"
	},
	"ETI_OPENFRXPART": {
		"descriptionQuestion": "Index of openness to foreign participation (1 = worst, 7 = best)",
		"dataType": "AGGREG",
		"globalId": "ETI_OPENFRXPART",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from World Economic Forum and International Trade Centre.",
		"title": "Openness to foreign participation (1–7)",
		"shortTitle": "Openness to foreign participation",
		"otherShortTitle": "Openness to foreign participation",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Openness to foreign participation index (1–7)",
		"fullDescription": "This indicator is a combination of the Ease of hiring foreign labour, Business impact of rules on FDI (both derived from the World Economic Forum's Executive Opinion Survey) and Openness to multilateral trade rules (International Trade Centre) indicators. See description of each individual indicator for more details.",
		"GETR2016Number": "7.04"
	},
	"SUN-TABTIMEEXPBORD": {
		"descriptionQuestion": "Time (hours) associated with compliance with the economy’s customs regulations and with regulations relating to other inspections that are mandatory in order for the shipment to cross the economy’s border, as well as the time and cost for handling that takes place at its port or border.  (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEEXPBORD",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to export: Border compliance (1-7)",
		"shortTitle": "Time to export: Border compliance",
		"otherShortTitle": "Time to export: Border compliance (hours)",
		"parentCategoryGlobalId": "EXPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to export: Border compliance (1-7)",
		"fullDescription": "The estimate takes into account exclusively exports of the product of the country's comparative advantage (defined by the largest export value) to its natural export partner—the economy that is the largest purchaser of this product. Precious metal and gems, mineral fuels, oil products, live animals, residues and waste of foods and products as well as pharmaceuticals are excluded from the list of possible export products, however, and in these cases the second largest product category is considered as needed. ",
		"GETR2016Number": "3.08"
	},
	"ETID": {
		"descriptionQuestion": "Subindex D: Operating environment",
		"dataType": "AGGREG",
		"globalId": "ETID",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Operating environment (1–7)",
		"shortTitle": "Subindex D: Operating environment",
		"otherShortTitle": "Operating environment",
		"parentCategoryGlobalId": "ETI",
		"includedDashboard": "YES",
		"titleWithUnits": "Subindex D: Operating environment (1–7)",
		"fullDescription": "This subindex assesses the quality of a country’s operating environment, which significantly impacts the capacity of companies that export, import, trade and/or transport merchandise to do business. It assesses a country’s level of protection of property rights, the quality and impartiality of its public institutions, efficiency in enforcing contracts, the availability of finance, openness to foreign participation in terms of foreign investments and labour, as well as the level of personal security approximated by the incidence of crime and terrorism",
		"GETR2016Number": "D"
	},
	"TFA Article 3": {
		"descriptionQuestion": "Advance rulings",
		"dataType": "HARD",
		"globalId": "TFA Article 3",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 3 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"ETIA02": {
		"descriptionQuestion": "Pillar 2: Foreign market access",
		"dataType": "AGGREG",
		"globalId": "ETIA02",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Foreign market access (1–7)",
		"shortTitle": "Pillar 2: Foreign market access",
		"otherShortTitle": "Foreign market access",
		"parentCategoryGlobalId": "ETI.A",
		"includedDashboard": "YES",
		"titleWithUnits": "Pillar 2: Foreign market access (1–7)",
		"fullDescription": "This pillar assesses tariff barriers faced by a country’s exporters in destination markets. It includes the average tariffs faced by the country as well as the margin of preference in destination markets negotiated through bilateral or regional trade agreements, or granted in the form of trade preferences.",
		"GETR2016Number": "A.02"
	},
	"ETI_SECURITY": {
		"descriptionQuestion": "Index of physical security (1 = lowest, 7 = highest)",
		"dataType": "AGGREG",
		"globalId": "ETI_SECURITY",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum's calculations based on data from World Economic Forum, United Nations Office on Drugs and Crime and START Global Terrorism Database",
		"title": "Physical security (1–7)",
		"shortTitle": "Physical security",
		"otherShortTitle": "Physical security",
		"parentCategoryGlobalId": "ETI.D.07",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Index of physical security (1–7)",
		"fullDescription": "This indicator is a combination of the Reliability of police services, Business costs of crime and violence and Business costs of terrorism (all derived from the World Economic Forum's Executive Opinion Survey), Homicide rate indicators and Incidence of terrorism. See description of each individual indicator for more details.",
		"GETR2016Number": "7.05"
	},
	"ETIC0403": {
		"descriptionQuestion": "Availability and quality of port infrastructure",
		"dataType": "AGGREG",
		"globalId": "ETIC0403",
		"rankDirection": "0",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "World Economic Forum, [i]The Global Enabling Trade Report 2016[i]",
		"title": "Availability and quality of port infrastructure (1–7)",
		"shortTitle": "Availability and quality of port infrastructure",
		"otherShortTitle": "Availability and quality of port infrastructure",
		"parentCategoryGlobalId": "ETI.C.04",
		"includedDashboard": "Not yet",
		"titleWithUnits": "Availability and quality of port infrastructure (1–7)",
		"fullDescription": "",
		"GETR2016Number": "C.04.03"
	},
	"TFA Article 10": {
		"descriptionQuestion": "Formalities connected with importation, exportation and transit",
		"dataType": "HARD",
		"globalId": "TFA Article 10",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "WTO Trade Facilitation Agreement Database",
		"sources": "World Trade Organization (WTO); TFA Database",
		"title": "TFA article 10 (0–100)",
		"shortTitle": "",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "",
		"includedDashboard": "YES",
		"titleWithUnits": "",
		"fullDescription": "",
		"GETR2016Number": "not included in GETR"
	},
	"EOSQ353": {
		"descriptionQuestion": "In your country, how is the quality (extensiveness and condition) of transport infrastructure for seaports (for landlocked countries – please assess access to seaports) (1 = extremely underdeveloped – among the worst in the world; 7 = extensive and efficient – among the best in the world)",
		"dataType": "SURVEY",
		"globalId": "EOSQ353",
		"rankDirection": "0",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1.27,
			6.82
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Quality of port infrastructure (1–7)",
		"shortTitle": "Quality of port infrastructure",
		"otherShortTitle": "Quality of port infrastructure",
		"parentCategoryGlobalId": "ETI.C.04.03",
		"includedDashboard": "YES",
		"titleWithUnits": "Quality of port infrastructure*",
		"fullDescription": "",
		"GETR2016Number": "4.05"
	},
	"EOSQ468": {
		"descriptionQuestion": "In your country, to what extent does the financial sector provide the products and services that meet the needs of businesses? (1 = not at all; 7 = to a great extent)",
		"dataType": "SURVEY",
		"globalId": "EOSQ468",
		"rankDirection": "",
		"fixed_domain": false,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			2.27,
			5.97
		],
		"sources": "World Economic Forum, [i]Executive Opinion Survey[i], 2015 and 2016 editions",
		"title": "Financial services meeting business needs (1-7)",
		"shortTitle": "Financial services meeting business needs",
		"otherShortTitle": "",
		"parentCategoryGlobalId": "ETI_FINANCE",
		"includedDashboard": "YES",
		"titleWithUnits": "Financial services meeting business needs*",
		"fullDescription": "",
		"GETR2016Number": "7.03.a"
	},
	"SUN-TABTIMEIMPDOC": {
		"descriptionQuestion": "Time (hours) associated with compliance with the documentary requirements of all government agencies of the origin economy, the destination economy and any transit economies. (1 = very low, 7  = very high)",
		"dataType": "HARD",
		"globalId": "SUN-TABTIMEIMPDOC",
		"rankDirection": "1",
		"fixed_domain": true,
		"refDatabase": "Global Enabling Trade Report",
		"domain": [
			1,
			7
		],
		"sources": "The World Bank, [i]Doing Business Trading Across Borders[i] ",
		"title": "Time to import: Documentary compliance (1-7)",
		"shortTitle": "Time to import: Documentary compliance",
		"otherShortTitle": "Time to import: Documentary compliance (hours)",
		"parentCategoryGlobalId": "IMPTIMECOMPLIANCEIDX",
		"includedDashboard": "YES",
		"titleWithUnits": "Time to import: Documentary compliance (1-7)",
		"fullDescription": "The estimate is based on a scenario whereby 15 metric tons of containerized auto parts (HS 8708) are being imported from the country's natural import partner—the economy from which it imports the largest value (price times quantity) of auto parts. ",
		"GETR2016Number": "3.03"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/data_indicators.json
// module id = 588
// module chunks = 0